// libs
import React from 'react';

// component
import ModalContent from './ModalContent';

// styles
import './styles.scss';

const propTypes = {};

function Modal(props) {
  document.getElementsByTagName('html')[0].style.overflowY = 'hidden';
  return (
    <div className="modal">
      <div className="modal__wrapper">
        <ModalContent {...props} />
      </div>
    </div>
  );
}

Modal.propTypes = propTypes;
Modal.defaultProps = {};

export default Modal;



// WEBPACK FOOTER //
// ./src/app/components/layouts/modal/Modal.js